// extracted by mini-css-extract-plugin
export default {"inventoryWidget":"SpecialBundleFooterContent_inventoryWidget"};